import styles from "./InternalOrder.module.scss";
import { bgColorbyName, orderStatusColors } from "src/variable/randomColor";
import { EMPTY_STRING } from "src/components/constant/constant";
import { formatFullName } from "src/utils";
import { Avatar, IconButton, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import { Order } from "../stripeTransactionHistory/stripeTransactionHistorySlice";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ReceiptIcon from "@mui/icons-material/Receipt";
import React from "react";

const columns = [
  {
    title: "Order ID",
    dataIndex: "order_id",
    key: "order_id"
  },
  {
    title: "Display ID",
    dataIndex: "display_id",
    key: "display_id"
  },
  {
    title: "User",
    dataIndex: "user",
    key: "user",
    render: (user: Order["user"], data: Order) => (
      <Link to={`/users/${data?.user?.user_id}`} className={styles.tableMember}>
        <div className={styles.tableMemberImg}>
          <Avatar
            id="av"
            aria-label="Recipe"
            style={{ backgroundColor: bgColorbyName(data?.user?.attributes?.first_name || EMPTY_STRING) }}
          >
            {data?.user?.attributes?.first_name?.charAt(0).toLocaleUpperCase()}
          </Avatar>
        </div>
        <div className={styles.tableMemberDetail}>
          <div className={styles.tableMemberName}>
            {formatFullName(data?.user?.attributes?.first_name, data?.user?.attributes?.last_name)}
          </div>
          <div className={styles.tableMemberEmail}>{data?.user?.email || EMPTY_STRING}</div>
        </div>
      </Link>
    )
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    render: (amount: number) => `$${amount?.toFixed(2) || "0.00"}`
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (status: string) => (
      <div className={styles.tableStatus}>
        <div
          className={styles.statusBadge}
          style={{
            backgroundColor: `${orderStatusColors[status]}0d`,
            borderColor: `${orderStatusColors[status]}73`,
            color: `${orderStatusColors[status]}FF`
          }}
        >
          {status || EMPTY_STRING}
        </div>
      </div>
    )
  }
];

export const itemsTableColumns = [
  {
    title: "Item ID",
    dataIndex: "order_item_id",
    key: "order_item_id"
  },
  {
    title: "Object ID",
    dataIndex: "object_id",
    key: "object_id"
  },
  {
    title: "Type",
    dataIndex: "order_item_type",
    key: "order_item_type"
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
    render: (amount: number) => `$${amount?.toFixed(2) || "0.00"}`
  }
];

type ExpandHandler = (_orderId: string, _isExpanded: boolean) => void;

export const createExpandIcon =
  (expandedRows: Set<string>, onExpand: ExpandHandler) =>
  ({ record }: { record: { order_id: string; __type?: "skeleton" | "empty" } }): React.ReactElement | null => {
    if (record.__type === "skeleton" || record.__type === "empty") {
      return null;
    }
    const orderId = record.order_id;
    const isExpanded = expandedRows.has(orderId);

    return (
      <IconButton
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          onExpand(orderId, isExpanded);
        }}
        className={styles.expandButton}
      >
        {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </IconButton>
    );
  };

export const createPaymentStatusColumn = (
  onPaymentStatusClick: (_orderId: string, _orderDisplayId: string) => void
) => ({
  title: EMPTY_STRING,
  dataIndex: EMPTY_STRING,
  key: "payment_status",
  render: (_: unknown, record: Order) => (
    <Tooltip title="View Payment Status">
      <IconButton
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          onPaymentStatusClick(record.order_id, record.display_id);
        }}
        className={styles.paymentStatusIcon}
      >
        <ReceiptIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  )
});

export default columns;
